import React from 'react'

export const Marquee = () => {
    return (
        <div class="flex   gap-4 bg-blue-400 px-4 py-1 text-gray-900 bg-[#fbf4f1]">
            <div class="flex  items-center w-16">
                    <p className='bg-blue text-[12px] inline-block text-center align-middle   mb-2 font-bold text-white mt-2 px-2'> News</p>
                {/* <div class="bg-blue  text-[#c0460b] px-3 py-1 h-[18px] w-auto  ">
                </div> */}
                <div class="w-0 h-0 border-t-[15px] border-t-transparent border-l-[15px] border-l-blue border-b-[15px] border-b-transparent"></div>
                
            </div>
            <div className='w-full ml-3'>
                <marquee behavior="" direction="right">
                    <ul className='text-[13px] inline-block align-middle text-[#c0460b]'>
                        <li>Self file your ITR for FY 23-24 absolutely FREE with India's Most Trusted Website.</li>
                    </ul>
                </marquee>
            </div>


        </div>
    )
}
